// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1hGeO","header":"MessagesList_header__3ZtZv","chat":"MessagesList_chat__1pbYL"};